import * as React from 'react';
import Credits from './Credits';
import Piece from './Piece';
import Swipe from 'ui-components/Swipe';
import {Work} from 'types/Work';
import {TouchData} from 'ui-components/Swipe';
import KeyShortcut from './KeyShortcut';


export class Gallery extends React.Component{
	constructor(props){
		super(props);
	}

	onClick = () => {
		let {
			mouseSide,
			next,
			previous
		} = this.props;
		if (mouseSide === -1){
			previous();
		}
		else{
			next();
		}
	}

	render(){
		let {
			work,
			mouseSide,
			setMouseSide,
			previous,
			next,
			nextRandom,
			videoEnded,
			tapData,
			debugVar
		} = this.props;

		return (
			<>
				<KeyShortcut 
					k="Enter"
					action={this.onClick}
				/>
				<KeyShortcut 
					k="ArrowLeft"
					action={previous}
				/>
				<KeyShortcut 
					k="ArrowRight"
					action={next}
				/>
				<KeyShortcut 
					k="ArrowRight"
					shift action={nextRandom}
				/>
				<KeyShortcut 
					k="ArrowUp"
					action={() => {
						this.props.navigateTo('/grid');
					}}
				/>
				<KeyShortcut
					k="ArrowDown"
					action={() => {
						this.props.navigateTo('/search');
					}}
				/>
				<Swipe
					className="gallery"
					onSwipeLeft={next}
					onSwipeRight={previous}
					onTap={() => {
						// do nothing
					}}
					onClick={() => this.onClick()}
				>
					<Piece {...this.props}/>
					<Credits
						work={work}
						visibleOnPropsChange={true}
						tapData={tapData}
					/>
				</Swipe>
			</>
		)
	}
}
export default Gallery;